import api from './api';

export const getClients = (params) => api.get('/clients', { params });
export const createClient = (data) => api.post('/clients', data);
export const getClient = (clientId) => api.get(`/clients/${clientId}`);
export const updateClient = (clientId, data) => api.patch(`/clients/${clientId}`, data);
export const addClientMember = (clientId, userId, role) => api.post(`/clients/${clientId}/members`, { userId, role });
export const removeClientMember = (clientId, userId) => api.delete(`/clients/${clientId}/members/${userId}`);
export const addClientGroup = (clientId, groupId) => api.post(`/clients/${clientId}/groups`, { groupId });
export const removeClientGroup = (clientId, groupId) => api.delete(`/clients/${clientId}/groups/${groupId}`);
export const getClientReportSummary = (clientId) => api.get(`/clients/${clientId}/report-summary`);
